<template>
  <div style="height: 70vh;overflow-y: auto;">
    <div slot="title" style="width: 100%;position: absolute;top: 0px; padding-top: 10px;">
      <el-row style="width: 100%;display: table;">
        <span
          style="display: table-cell;vertical-align: middle;line-height: 24px;font-size: 18px;color: #303133;">预览</span>
        <span
          style="width: 500px;display: block;float: left;display: table-cell;vertical-align: middle;line-height: 24px;">(提示：点击导出后出现打印页面，可直接打印或保存为pdf格式。保存时时间过长，请耐心等待。保存进度在操作系统右下角的打印服务中。)</span>
        <el-button type="primary" v-print="print" style="float:right;margin-right: 80px;">导出</el-button>
      </el-row>
    </div>
    <div id="printArea">
      <h v-if="dateType=='1'">{{(date.split("-")[0]+"-"+date.split("-")[1]+"月")}}报告</h>
      <h v-if="dateType=='2'">{{(date.split("-")[0]+"年")}}报告</h>
      <h v-if="dateType=='3'">{{(date.split("-")[0]+"年1-6月")}}报告</h>
      <h v-if="dateType=='4'">{{(date.split("-")[0]+"年7-12月")}}报告</h>







      <h1>一、总体概览</h1>
      <h2>(一)&nbsp;项目概况</h2>
      <el-table :data="xmgkdata" border>
        <el-table-column prop="content" label="内容">
        </el-table-column>
        <el-table-column prop="info" label="目前情况">
        </el-table-column>
      </el-table>


      <h2>(二)&nbsp;运行能耗</h2>

      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">

        <div class="el-table__header-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 717px;">
            <colgroup>
              <col name="el-table_3_column_5" width="359">
              <col name="el-table_3_column_6" width="358">
              <col name="gutter" width="0">
            </colgroup>
            <thead class="has-gutter">
              <tr class="">
                <th colspan="1" rowspan="1" class="el-table_3_column_5     is-leaf el-table__cell">
                  <div class="cell">
                    <h3 v-if="dateType=='1'">当月总用电</h3>
                    <h3 v-if="dateType!='1'">当前年总用电</h3>
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="el-table_3_column_6     is-leaf el-table__cell">
                  <div class="cell">
                    <h3>尖峰谷平</h3>
                  </div>
                </th>
                <th class="el-table__cell gutter" style="width: 0px; display: none;"></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">

                    <div class="box">
                      <div class="left vflex">
                        <div class="top"><span class="card-panel-num" data-v-3be0a972="" style="font-weight: bold;">
                            {{todayUseElect}}
                          </span></div>
                        <div class="bottom">
                          {{dateType=='1'?'上月':'去年'}}同期：{{compareUseElect}}kWh </div>
                      </div>
                      <div class="middle vflex">
                        <div class="top" style="align-self: baseline;">kWh</div>
                        <div class="bottom" style="align-self: baseline;"><span>环比 </span>
                          <span>
                            {{tb*100}}%</span>
                          <span v-if="tb < 0" style="color: #33cc8d;font-size: 25px;"> ⬇ </span><span v-if="tb > 0"
                            style="color: #fc5656;font-size: 25px;"> ⬆</span>
                        </div>
                      </div>
                    </div>


                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_6   el-table__cell">
                  <div class="cell" style="    width: 100%; height: 300px;">
                    <v-chart :option="optionsjfgp" ref="chart2" style="width: 300px;height: 300px;"></v-chart>
                  </div>
                </td>
              </tr>


              <tr class="el-table__row">
                <td rowspan="1" colspan="2" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 300px;width: 100%;padding-top: 15px;">
                      <v-chart :option="optionsydqs" ref="chart"></v-chart>
                    </div>
                    <el-table :data="ydqsTableData" border style="width: 500px;margin: 30px auto;">
                      <el-table-column prop="date" :label="dateType=='1'?'日期':'月份'">
                      </el-table-column>
                      <el-table-column prop="ben" :label="dateType=='1'?'本月':'当前年'">
                      </el-table-column>
                      <el-table-column prop="shang" :label="dateType=='1'?'上月':'去年'">
                      </el-table-column>
                      <el-table-column prop="huanbi" label="环比">
                      </el-table-column>
                    </el-table>
                  </div>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>



      <h2>(三)&nbsp;运行质量</h2>
      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;" v-for="(item, index) in yxzlData" :key="index">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>{{item.info.address}}</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>电室: {{item.info.room}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>编号: {{item.info.localNumber}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>描述: {{item.info.desc}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>告警数: {{item.info.alarm}}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="yxzldybphd" manual-update></v-chart>
                    </div>

                    <!-- <el-table border :data="item.dyTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianya">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.dyTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianya">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.dyTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianya">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.dyTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianya">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table> -->

                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="yxzldlbphd" manual-update></v-chart>
                    </div>

                    <el-table border :data="item.dlTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianliu">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1' || dateType == '2'" border :data="item.dlTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianliu">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1'" border :data="item.dlTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianliu">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1'" border :data="item.dlTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianliu">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                  </div>
                </td>
              </tr>


            </tbody>
          </table>
        </div>
      </div>





      <div style="page-break-after:always"></div>
      <h1>二、用电统计</h1>
      <h2>(一)&nbsp;变压器用电情况</h2>
      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;" v-for="(item, index) in byqData" :key="'byq' + index">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>{{item.info.address}}</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>电室: {{item.info.room}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>编号: {{item.info.localNumber}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="2" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>描述: {{item.info.desc}}</span>
                    </div>
                  </div>
                </td>

              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border :data="item.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in item.power">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table  border :data="item.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in item.power">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in item.power">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in item.power">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="byqfhChart" manual-update></v-chart>
                    </div>

                    <el-table border :data="item.fhTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.fuhe">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1' || dateType == '2'" border :data="item.fhTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.fuhe">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1' " border :data="item.fhTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.fuhe">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1' " border :data="item.fhTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.fuhe">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>

              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="byqfhAVChart" manual-update></v-chart>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>






      <h2>(二)&nbsp;馈线回路用电统计（前十）</h2>
      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;" v-for="(item, index) in hlData" :key="'huilu' +index">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>{{item.info.address}}</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>电室: {{item.info.room}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>编号: {{item.info.localNumber}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="2" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>描述: {{item.info.desc}}</span>
                    </div>
                  </div>
                </td>

              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border :data="item.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in item.power">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in item.power">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in item.power">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in item.power">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>



            </tbody>
          </table>
        </div>
      </div>







      <h2>(三)&nbsp;负载类别统计</h2>
      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>动力用电</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border :data="fzData.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.power">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.power">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.power">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.powerValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.power">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>照明用电</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border :data="fzData.lightingValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.lighting">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.lightingValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.lighting">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.lightingValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.lighting">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.lightingValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.lighting">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>空调用电</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border :data="fzData.electricityValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.electricity">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.electricityValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.electricity">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.electricityValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.electricity">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.electricityValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.electricity">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>


          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>机房用电</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border :data="fzData.roomValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.room">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.roomValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.room">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.roomValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.room">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.roomValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.room">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>


          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>电锅炉用电</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border :data="fzData.boilersValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.boilers">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.boilersValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.boilers">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.boilersValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.boilers">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.boilersValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.boilers">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>其他用电</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border :data="fzData.otherValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.other">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.otherValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.other">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.otherValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.other">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="fzData.otherValue" style="width: 649px;">

                      <template v-for="(item2, index2) in fzData.other">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>




        </div>
      </div>





      <div style="page-break-after:always"></div>
      <h1>三、用电分析</h1>
      <h2>(一)&nbsp;电流不平衡</h2>

      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;" v-for="(item, index) in dlbphData" :key="'dlbph' + index">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>{{item.info.address}}</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>电室: {{item.info.room}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>编号: {{item.info.localNumber}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="2" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>描述: {{item.info.desc}}</span>
                    </div>
                  </div>
                </td>

              </tr>

              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="dlbphChart" manual-update></v-chart>
                    </div>

                    <el-table border :data="item.dlbphTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianliu">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1' || dateType == '2'" border :data="item.dlbphTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianliu">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1'" border :data="item.dlbphTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianliu">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1'" border :data="item.dlbphTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.dianliu">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>

              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="dlbphAVChart" manual-update></v-chart>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>





      <h2>(二)&nbsp;环境温度统计</h2>
      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;" v-for="(item, index) in huanjingData" :key="'wendu' + index">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>{{item.info.address}}</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>电室: {{item.info.room}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>编号: {{item.info.localNumber}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="2" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>描述: {{item.info.desc}}</span>
                    </div>
                  </div>
                </td>

              </tr>

              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="huanjingChart" manual-update></v-chart>
                    </div>

                    <el-table border :data="item.huanjingTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.wendu">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1' || dateType == '2'" border :data="item.huanjingTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.wendu">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1' " border :data="item.huanjingTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.wendu">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table v-if="dateType == '1'" border :data="item.huanjingTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.wendu">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>

              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="huanjingavChart" manual-update></v-chart>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>





      <h2>(三)&nbsp;电能质量</h2>

      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;" v-for="(item, index) in dnzlData" :key="'dnzl' + index">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>{{item.info.address}}</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>电室: {{item.info.room}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>编号: {{item.info.localNumber}}</span>
                    </div>
                  </div>
                </td>
                <td rowspan="1" colspan="2" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div>
                      <span>描述: {{item.info.desc}}</span>
                    </div>
                  </div>
                </td>

              </tr>

              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="dnzlChart" manual-update></v-chart>
                    </div>

                    <!-- <el-table border :data="item.dnzlTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.yinshu">
                        <el-table-column :key="index2" v-if="index2 < 9" :prop="item2.day" :label="item2.day" width="72"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.dnzlTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.yinshu">
                        <el-table-column :key="index2" v-if="index2 >= 9 && index2 < 18" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.dnzlTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.yinshu">
                        <el-table-column :key="index2" v-if="index2 >= 18 && index2 < 27" :prop="item2.day"
                          :label="item2.day" width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table>
                    <el-table border :data="item.dnzlTableData">
                      <el-table-column type="index" :index="indexMethod" width="42">
                      </el-table-column>
                      <template v-for="(item2, index2) in item.yinshu">
                        <el-table-column :key="index2" v-if="index2 >= 27 " :prop="item2.day" :label="item2.day"
                          width="72" align="center" className="aabbshenmz">
                        </el-table-column>
                      </template>
                    </el-table> -->

                  </div>
                </td>
              </tr>

              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <div style="height: 200px;width: 100%;padding-top: 15px;">
                      <v-chart ref="dnzlavChart" manual-update></v-chart>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


      <div style="page-break-after:always"></div>
      <h1>四、事件统计</h1>
      <h2>(一)&nbsp;总表</h2>
      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>告警总揽</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="5" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border stripe :data="gjData.powerValue" style="font-size: 11px;">
                      <template v-for="(item2, index2) in gjData.power">
                        <el-table-column v-if="index2 == 0 " :key="index2" :prop="item2" :label="item2" width="75"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                          <template slot-scope="scope">
                            <el-tag :type="scope.row.总计 != 0 ? 'danger' : 'success'"
                              disable-transitions>{{scope.row.告警名称}}</el-tag>
                          </template>
                        </el-table-column>
                        <el-table-column v-if="index2 == 1 " :key=" index2" :prop="item2" :label="item2" width="36"
                          align="center" style="background-color: #ebeef5;" className="aabbshenmz">
                        </el-table-column>
                        <el-table-column v-if="index2 == 2 " :key=" index2" :prop="'day'" label="单日详情" align="center"
                          style="background-color: #ebeef5;" className="aabbshenmz">
                          <template slot-scope="scope">

                            <el-table border :data="[scope.row]" style="width: 581px;">
                              <template v-for="(item2, index2) in gjData.power">
                                <el-table-column :key="index2" v-if="index2 < 18 && index2 > 1" :prop="item2"
                                  :label="item2" width="36" align="center"
                                  :className="'aabbshenmz ' + (scope.$index%2 == 0?'':'cell_back_color')">
                                </el-table-column>
                              </template>
                            </el-table>
                            <el-table border :data="[scope.row]" style="width: 541px;">
                              <template v-for="(item2, index2) in gjData.power">
                                <el-table-column :key="index2" v-if="index2 >= 18" :prop="item2" :label="item2"
                                  width="36" align="center"
                                  :className="'aabbshenmz ' + (scope.$index%2 == 0?'':'cell_back_color')">
                                </el-table-column>
                              </template>
                            </el-table>


                          </template>
                        </el-table-column>
                      </template>
                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>






        </div>
      </div>



      <h2>(二)&nbsp;遥测越限统计（前十）</h2>
      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>设备过载</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>设备重载</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">
                    <el-table border stripe :data="ycyxData.sbgz" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>


                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border stripe :data="ycyxData.sbcz" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>设备低限</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>设备低低限</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">
                    <el-table border stripe :data="ycyxData.sbdx" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>


                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border stripe :data="ycyxData.sbddx" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>





      <h2>(三)&nbsp;遥信越位统计（前十）</h2>
      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>闭合</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>断开</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">
                    <el-table border stripe :data="yxywData.bh" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>


                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border stripe :data="yxywData.dk" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>恢复</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>跳闸恢复</h3>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">
                    <el-table border stripe :data="yxywData.hf" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>


                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">

                    <el-table border stripe :data="yxywData.tzhf" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="margin-top: 20px;">
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 717px;">

            <tbody>
              <tr class="el-table__row tr_header">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">
                    <h3>异常断开</h3>
                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell">

                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">
                    <el-table border stripe :data="yxywData.ycdk" style="font-size: 11px;width: 100%;">

                      <el-table-column prop="address" label="仪表位置" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="localNumber" label="现场编号" width="65" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="count" label="报警次数" width="45" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>
                      <el-table-column prop="desc" label="设备描述" width="155" align="center"
                        style="background-color: #ebeef5;" className="aabbshenmz">
                      </el-table-column>

                    </el-table>


                  </div>
                </td>
                <td rowspan="1" colspan="1" class="el-table_3_column_5   el-table__cell">
                  <div class="cell" style="padding: 10px 10px;">



                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
  import print from 'vue-print-nb'
  import ECharts from "vue-echarts";
  export default {
    name: " pdf", directives: { print }, data () {
      return {
        print: {
          id: 'printArea', popTitle: '',
          previewBeforeOpenCallback () { },
          beforeOpenCallback () { }, openCallback () { },
          closeCallback () { }, url: '', standard: '', extraCss: '',
        },
        xmgkdata: [],
        optionsjfgp: {

          legend: {
            textStyle: {
              fontSize: 11
            },
            left: 'center',
            top: "bottom"
          },
          series: [
            {

              type: 'pie',
              radius: ['0%', '30%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                alignTo: 'edge',
                formatter: '{name|{c}}, 占{d}%\n{time|{b} kWh}',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 35,
                rich: {
                  time: {
                    fontSize: 11,
                    color: '#999'
                  }
                },
                textStyle: {
                  fontSize: 11
                },
              },

              labelLine: {
                length: 55,
                length2: 70,
                maxSurfaceAngle: 40
              },
              data: [
                { value: 0, name: '尖电量' },
                { value: 0, name: '峰电量' },
                { value: 0, name: '谷电量' },
                { value: 0, name: '平电量' }
              ]
            }
          ]
        },
        optionsydqs: {
          title: {
            text: "用电趋势", textStyle: {
              fontSize: 15,
              color: '#000'
            },
          },
          color: ['#5470C6', '#00CE7C60'],
          tooltip: {
            trigger: "axis",
            formatter: function (params) {
              let params1 = params[0];
              let params2 = params[1];
              return (
                params.length == 1 ? params1.marker + params1.seriesName + '<br/>' +
                  params1.axisValueLabel + (params1.value ? "" : "---") :
                  params2.marker + params2.seriesName + '<br/>' +
                  params2.axisValueLabel + (params2.value ? "" : "---") +
                  '<br/>' +
                  params1.marker + params1.seriesName + '<br/>' +
                  params1.axisValueLabel + (params1.value ? "" : "---") +
                  '<br/><br/>' +
                  params2.marker + params1.marker + "环比：" + ((params1.value - params2.value) / params2.value * 100).toFixed(2) + '%'


              );
            },
            axisPointer: {
              animation: false
            }

          },
          legend: {},
          grid: {
            top: 50,
            bottom: 50
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: '#5470C6'
                }
              },
              axisPointer: {
                label: {
                  formatter: function (params) {
                    return (
                      'Precipitation  ' +
                      params.value +
                      (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                    );
                  }
                }
              },
              // prettier-ignore
              data: []
            },
            {
              type: 'category',
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: '#00CE7C'
                }
              },
              axisPointer: {
                label: {
                  formatter: function (params) {
                    return (
                      'Precipitation  ' +
                      params.value +
                      (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                    );
                  }
                }
              },
              // prettier-ignore
              data: []
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '当月用电',
              type: 'line',
              xAxisIndex: 0,
              smooth: true,
              emphasis: {
                focus: 'series'
              },
              data: [],
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: "rgba(20, 96, 224, 0.5)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(20, 96, 224, 0)", // 100% 处的颜色
                  },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            {
              name: '上月用电',
              type: 'line',
              smooth: true,
              xAxisIndex: 1,
              emphasis: {
                focus: 'series'
              },
              data: [],
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: "rgba(0, 206, 124, 0.3)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 206, 124, 0)", // 100% 处的颜色
                  },
                  ],
                  global: false, // 缺省为 false
                },
              }
            }
          ]
        },
        todayUseElect: 0,
        compareUseElect: 0,
        tb: 0,
        ydqsTableData: [],
        yxzlData: [],
        byqData: [],
        hlData: [],
        fzData: [],
        dlbphData: [],
        huanjingData: [],
        dnzlData: [],
        gjData: [],
        ycyxData: [],
        yxywData: []
      };
    }, props: { date: { type: String }, dateType: { type: String } },
    components: { "v-chart": ECharts },
    mounted () {

    },
    computed: {}, watch: {},
    created () {
      this.searchProductInfo()
    },
    methods: {
      indexMethod (index) {
        if (index == 0) {
          return '最高'
        } else if (index == 1) {
          return '时间'
        } else if (index == 2) {
          return '最低'
        } else if (index == 3) {
          return '时间'
        }
      },
      searchProductInfo () {
        const projectId = this.$getCookie("projectId");
        this.$http
          .post(
            "bma-distribution-service/monthReport/getPdfInfo", {
            projectId: projectId,
            date: this.date,
            dateType: this.dateType
          }
          )
          .then((res) => {
            if (res.data) {
              this.xmgkdata = res.data.xmgkdata

              this.todayUseElect = res.data.searchProjectElect.todayUseElect
              this.compareUseElect = res.data.searchProjectElect.compareUseElect
              this.tb = res.data.searchProjectElect.tb

              if (res.data.searchPeak.jian == 0) {
                this.optionsjfgp.series[0].data = [
                  { value: res.data.searchPeak.feng, name: '峰电量' },
                  { value: res.data.searchPeak.gu, name: '谷电量' },
                  { value: res.data.searchPeak.ping, name: '平电量' }
                ]

              } else {
                this.optionsjfgp.series[0].data = [
                  { value: res.data.searchPeak.jian, name: '尖电量' },
                  { value: res.data.searchPeak.feng, name: '峰电量' },
                  { value: res.data.searchPeak.gu, name: '谷电量' },
                  { value: res.data.searchPeak.ping, name: '平电量' }
                ]
              }


              this.$refs.chart2.setOption(this.optionsjfgp, true);
              this.yongdianqushiChart(res.data.searchProjectElect, 1, this.dateType)
              this.yunxingzhiliang(res.data.searchYunxingzhiliang)
              this.bianyaqi(res.data.searchBianyaqi)

              this.huilu(res.data.searchHuilu)
              this.fuzai(res.data.searchLoadCategory)
              this.dianliubupingheng(res.data.searchDianliu)
              this.huanjing(res.data.searchHuanjing)
              this.dnzl(res.data.searchDianneng)
              this.gjzl(res.data.searchAlarm)
              this.ycyx(res.data.searchTelemetryOverLimit)
              this.yxyw(res.data.searchRemoteSignalOffside)


            }
          });
      },
      yongdianqushiChart (searchProjectElect, type, dateType) {


        if (type == 1 || type == 2) {

          // 用电趋势
          let useElectrics = searchProjectElect.useElectrics;
          let compareUseElectrics = searchProjectElect.compareUseElectrics;
          // x轴
          let iFlag = 0;
          let xAxis = [];
          let xAxis2 = [];
          // 截至时间
          let newFlag = 0;
          let ii = 0;
          if (dateType == '1') {
            ii = 1;
            iFlag = 31;
            for (let i = 1; i <= (searchProjectElect.compareUseElectricsMonthDays); i++) {
              xAxis2.push(searchProjectElect.compareUseElectricsMonth + "-" + i + "日");
            }
            for (let i = 1; i <= (31 - searchProjectElect.compareUseElectricsMonthDays + 1); i++) {
              xAxis2.push("-")
            }

            for (let i = 1; i <= (searchProjectElect.useElectricsMonthDays); i++) {
              xAxis.push(searchProjectElect.useElectricsMonth + "-" + i + "日");
            }
            for (let i = 1; i <= (31 - searchProjectElect.useElectricsMonthDays + 1); i++) {
              xAxis.push("-")
            }
            newFlag = new Date().getDate();
          } else if (dateType == '2') {
            ii = 1;
            iFlag = 12;
            for (let i = 1; i <= 12; i++) {
              xAxis.push(i + "月");
            }
            newFlag = new Date().getMonth() + 1;
          } else if (dateType == '3') {
            ii = 1;
            iFlag = 6;
            for (let i = 1; i <= 6; i++) {
              xAxis.push(i + "月");
            }
            newFlag = new Date().getMonth() + 1;
          } else if (dateType == '4') {
            ii = 7;
            iFlag = 12;
            for (let i = 7; i <= 12; i++) {
              xAxis.push(i + "月");
            }
            newFlag = new Date().getMonth() + 1;
          }
          // 已有的时间list
          let dateList1 = [];
          let dateList2 = [];
          // 数据list
          let data1 = [];
          let data2 = [];
          // 求最大电量和用电时间
          let maxElect = 0;
          if (useElectrics) {
            useElectrics.forEach((item) => {
              dateList1.push(item.date);
              if (Number(item.electric) > maxElect) {
                maxElect = Number(item.electric);
              }
            });
          }
          if (compareUseElectrics) {
            compareUseElectrics.forEach((item) => {
              dateList2.push(item.date);
            });
          }
          for (let i = ii; i <= iFlag; i++) {
            let index1 = dateList1.indexOf(i);
            if (index1 > -1) {
              data1.push(this.$genderMenu(useElectrics[index1].electric));
            } else if (index1 == -1 && i <= newFlag) {
              data1.push(0);
            } else {
              data1.push("");
            }

            let index2 = dateList2.indexOf(i);
            if (index2 > -1) {
              data2.push(
                this.$genderMenu(compareUseElectrics[index2].electric)
              );
            } else {
              data2.push('');
            }
          }
          if (dateType == "1") {
            this.optionsydqs.series[0].name = "当月用电"
            this.optionsydqs.series[1].name = "上月用电"
          } else {
            this.optionsydqs.series[0].name = "当前年用电"
            this.optionsydqs.series[1].name = "去年用电"
          }
          this.optionsydqs.xAxis[0].data = xAxis;
          this.optionsydqs.xAxis[1].data = xAxis2;

          this.optionsydqs.xAxis[0].axisPointer.label.formatter = function (params) {
            return (
              searchProjectElect.useElectricsYear + "-" +
              params.value +
              (params.seriesData.length ? '：' + params.seriesData[0].data : '')
            );
          }
          this.optionsydqs.xAxis[1].axisPointer.label.formatter = function (params) {
            return (
              searchProjectElect.compareUseElectricsYear + "-" +
              params.value +
              (params.seriesData.length ? '：' + params.seriesData[0].data : '')
            );
          }

          this.$refs.chart.setOption(this.optionsydqs, true);
          this.maxElect = maxElect;

          this.optionsydqs.series[0].data = data1
          this.optionsydqs.series[1].data = data2

          if (this.dateType == '1') {
            for (let i = 0; i < 31; i++) {
              let obj = { "date": i + 1 + "日", "ben": data1[i], "shang": data2[i], "huanbi": ((data1[i] - data2[i]) / data2[i] * 100).toFixed(2) + '%' }
              this.ydqsTableData.push(obj)
            }
          } else if (this.dateType == '2') {
            for (let i = 0; i < 12; i++) {
              let obj = { "date": i + 1 + "月", "ben": data1[i], "shang": data2[i], "huanbi": ((data1[i] - data2[i]) / data2[i] * 100).toFixed(2) + '%' }
              this.ydqsTableData.push(obj)
            }
          } else if (this.dateType == '3') {
            for (let i = 0; i < 6; i++) {
              let obj = { "date": i + 1 + "月", "ben": data1[i], "shang": data2[i], "huanbi": ((data1[i] - data2[i]) / data2[i] * 100).toFixed(2) + '%' }
              this.ydqsTableData.push(obj)
            }
          } else if (this.dateType == '4') {
            for (let i = 6; i < 12; i++) {
              let obj = { "date": i + 1 + "月", "ben": data1[i - 6], "shang": data2[i - 6], "huanbi": ((data1[i - 6] - data2[i - 6]) / data2[i - 6] * 100).toFixed(2) + '%' }
              this.ydqsTableData.push(obj)
            }
          }



        }
      },
      yunxingzhiliang (data) {
        this.yxzlData = data.datas
        this.$nextTick(() => {

          let options = {
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let params1 = params[0];
                let params2 = params[1];
                return (
                  params.length == 1 ? params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value :

                    params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value +
                    '<br/>' +
                    params2.marker + params2.seriesName + '<br/>' +
                    params2.axisValue + "：" + params2.value



                );
              },
              axisPointer: {
                animation: false
              }

            },
            title: {
              text: "电压不平衡度", textStyle: {
                fontSize: 15,
                color: '#000'
              },
            },
            color: ['#5470C6', '#00CE7C60'],
            legend: {},
            grid: {
              top: 30,
              bottom: 50
            },
            xAxis: [
              {
                splitArea: {
                  show: true
                },
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#5470C6'
                  }
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      return (
                        params.value +
                        (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                      );
                    }
                  }
                },
                // prettier-ignore
                data: []
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '最高',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [
                  2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
                ]
              },
              {
                name: '最低',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [
                  3.9, 5.9, 11.1, 18.7, 48.3, 69.2, 231.6, 46.6, 55.4, 18.4, 10.3, 0.7
                ]
              }
            ]
          }


          let shebeiIndex = 0
          this.yxzlData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.dianya.forEach((item) => {

              options.xAxis[0].data.push(item.day)
              options.series[0].data.push(item.max)
              options.series[1].data.push(item.min)
            })

            this.$refs.yxzldybphd[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })

          options.title = {
            text: "电流不平衡度", textStyle: {
              fontSize: 15,
              color: '#000'
            },
          },
            shebeiIndex = 0
          this.yxzlData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.dianliu.forEach((item) => {

              options.xAxis[0].data.push(item.day)
              options.series[0].data.push(item.max)
              options.series[1].data.push(item.min)
            })
            this.$refs.yxzldlbphd[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })
        })

        // this.yxzlData.forEach((data) => {

        //   const days = []
        //   data.dianya.forEach((item) => {
        //     days.push(item.day)
        //   })



        //   const obj = {}
        //   const obj2 = {}
        //   const obj3 = {}
        //   const obj4 = {}
        //   days.forEach((item, index) => {
        //     obj[item] = data.dianya[index].max
        //     obj2[item] = data.dianya[index].maxTime.split(" ")[1]
        //     obj3[item] = data.dianya[index].min
        //     obj4[item] = data.dianya[index].minTime.split(" ")[1]
        //   })
        //   const dyTableData = [obj, obj2, obj3, obj4]
        //   data["dyTableData"] = dyTableData

        // })


        this.yxzlData.forEach((data) => {

          const days = []
          data.dianliu.forEach((item) => {
            days.push(item.day)
          })



          const obj = {}
          const obj2 = {}
          const obj3 = {}
          const obj4 = {}
          days.forEach((item, index) => {
            obj[item] = data.dianliu[index].max
            obj2[item] = data.dianliu[index].maxTime.split(" ")[1]
            obj3[item] = data.dianliu[index].min
            obj4[item] = data.dianliu[index].minTime.split(" ")[1]
          })
          const dlTableData = [obj, obj2, obj3, obj4]
          data["dlTableData"] = dlTableData

        })



      },
      bianyaqi (data) {
        this.byqData = data.datas

        this.byqData.forEach((data) => {

          let obj = {}
          data.power.forEach((item) => {
            obj[item.day] = item.value;
          })
          let tempArray = []
          tempArray.push(obj)
          data["powerValue"] = tempArray
        })

        this.$nextTick(() => {

          let options = {
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let params1 = params[0];
                let params2 = params[1];
                return (
                  params.length == 1 ? params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value :

                    params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value +
                    '<br/>' +
                    params2.marker + params2.seriesName + '<br/>' +
                    params2.axisValue + "：" + params2.value



                );
              },
              axisPointer: {
                animation: false
              }

            },
            title: { text: "负荷" },
            color: ['#5470C6', '#00CE7C60'],
            legend: {},
            grid: {
              top: 30,
              bottom: 50
            },
            xAxis: [
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#5470C6'
                  }
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      return (
                        params.value +
                        (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                      );
                    }
                  }
                },
                // prettier-ignore
                data: []
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '最高',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [

                ]
              },
              {
                name: '最低',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [

                ]
              }
            ]
          }


          let shebeiIndex = 0
          this.byqData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.fuhe.forEach((item) => {

              options.xAxis[0].data.push(item.day)
              options.series[0].data.push(item.max)
              options.series[1].data.push(item.min)
            })
            this.$refs.byqfhChart[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })
          if(this.dateType == '1'){
            options.title = { text: "平均负荷(小时)" };
          }else{
            options.title = { text: "平均负荷(天)" };
          }
          
          options.series[0].name = "平均值";
          options.series[1] = {}

          shebeiIndex = 0
          this.byqData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.fuheav.forEach((item) => {

              options.xAxis[0].data.push(item.hour)
              options.series[0].data.push(item.av)
            })
            this.$refs.byqfhAVChart[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })




        })


        this.byqData.forEach((data) => {

          const days = []
          data.fuhe.forEach((item) => {
            days.push(item.day)
          })
          const obj = {}
          const obj2 = {}
          const obj3 = {}
          const obj4 = {}
          days.forEach((item, index) => {
            obj[item] = data.fuhe[index].max
            obj2[item] = data.fuhe[index].maxTime.split(" ")[1]
            obj3[item] = data.fuhe[index].min
            obj4[item] = data.fuhe[index].minTime.split(" ")[1]
          })
          const fhTableData = [obj, obj2, obj3, obj4]
          data["fhTableData"] = fhTableData

        })
      },
      huilu (data) {
        this.hlData = data.datas

        this.hlData.forEach((data) => {

          let obj = {}
          data.power.forEach((item) => {
            obj[item.day] = item.value;
          })
          let tempArray = []
          tempArray.push(obj)
          data["powerValue"] = tempArray
        })


      },
      fuzai (data) {
        this.fzData = data

        {
          let tempArray = {}
          this.fzData.power.forEach((data) => {

            tempArray[data.day] = data.value

          })
          const dataArray = []
          dataArray.push(tempArray)
          this.fzData["powerValue"] = dataArray
        }

        {
          let tempArray = {}
          this.fzData.lighting.forEach((data) => {

            tempArray[data.day] = data.value

          })
          const dataArray = []
          dataArray.push(tempArray)
          this.fzData["lightingValue"] = dataArray
        }
        {
          let tempArray = {}
          this.fzData.electricity.forEach((data) => {

            tempArray[data.day] = data.value

          })
          const dataArray = []
          dataArray.push(tempArray)
          this.fzData["electricityValue"] = dataArray
        }
        {
          let tempArray = {}
          this.fzData.room.forEach((data) => {

            tempArray[data.day] = data.value

          })
          const dataArray = []
          dataArray.push(tempArray)
          this.fzData["roomValue"] = dataArray
        }
        {
          let tempArray = {}
          this.fzData.boilers.forEach((data) => {

            tempArray[data.day] = data.value

          })
          const dataArray = []
          dataArray.push(tempArray)
          this.fzData["boilersValue"] = dataArray
        }
        {
          let tempArray = {}
          this.fzData.other.forEach((data) => {

            tempArray[data.day] = data.value

          })
          const dataArray = []
          dataArray.push(tempArray)
          this.fzData["otherValue"] = dataArray
        }


      },
      dianliubupingheng (data) {

        this.dlbphData = data.datas


        this.$nextTick(() => {

          let options = {
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let params1 = params[0];
                let params2 = params[1];
                return (
                  params.length == 1 ? params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value :

                    params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value +
                    '<br/>' +
                    params2.marker + params2.seriesName + '<br/>' +
                    params2.axisValue + "：" + params2.value



                );
              },
              axisPointer: {
                animation: false
              }

            },
            title: { text: "电流不平衡度" },
            color: ['#5470C6', '#00CE7C60'],
            legend: {},
            grid: {
              top: 30,
              bottom: 50
            },
            xAxis: [
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#5470C6'
                  }
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      return (
                        params.value +
                        (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                      );
                    }
                  }
                },
                // prettier-ignore
                data: []
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '最高',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [

                ]
              },
              {
                name: '最低',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [

                ]
              }
            ]
          }


          let shebeiIndex = 0
          this.dlbphData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.dianliu.forEach((item) => {

              options.xAxis[0].data.push(item.day)
              options.series[0].data.push(item.max)
              options.series[1].data.push(item.min)
            })
            this.$refs.dlbphChart[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })
          if(this.dateType == '1'){
            options.title = { text: "电流不平衡度平均值(小时)" };
          }else{
            options.title = { text: "电流不平衡度平均值(天)" };
          }
          
          options.series[0].name = "平均值";
          options.series[1] = {}

          shebeiIndex = 0
          this.dlbphData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.dianliuav.forEach((item) => {

              options.xAxis[0].data.push(item.hour)
              options.series[0].data.push(item.av)
            })
            this.$refs.dlbphAVChart[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })




        })


        this.dlbphData.forEach((data) => {

          const days = []
          data.dianliu.forEach((item) => {
            days.push(item.day)
          })
          const obj = {}
          const obj2 = {}
          const obj3 = {}
          const obj4 = {}
          days.forEach((item, index) => {
            obj[item] = data.dianliu[index].max
            obj2[item] = data.dianliu[index].maxTime.split(" ")[1]
            obj3[item] = data.dianliu[index].min
            obj4[item] = data.dianliu[index].minTime.split(" ")[1]
          })
          const dlbphTableData = [obj, obj2, obj3, obj4]
          data["dlbphTableData"] = dlbphTableData

        })
      },
      huanjing (data) {

        this.huanjingData = data.datas


        this.$nextTick(() => {

          let options = {
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let params1 = params[0];
                let params2 = params[1];
                return (
                  params.length == 1 ? params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value :

                    params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value +
                    '<br/>' +
                    params2.marker + params2.seriesName + '<br/>' +
                    params2.axisValue + "：" + params2.value



                );
              },
              axisPointer: {
                animation: false
              }

            },
            title: { text: "温度统计" },
            color: ['#5470C6', '#00CE7C60'],
            legend: {},
            grid: {
              top: 30,
              bottom: 50
            },
            xAxis: [
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#5470C6'
                  }
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      return (
                        params.value +
                        (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                      );
                    }
                  }
                },
                // prettier-ignore
                data: []
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '最高',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [

                ]
              },
              {
                name: '最低',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [

                ]
              }
            ]
          }


          let shebeiIndex = 0
          this.huanjingData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.wendu.forEach((item) => {

              options.xAxis[0].data.push(item.day)
              options.series[0].data.push(item.max)
              options.series[1].data.push(item.min)
            })
            this.$refs.huanjingChart[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })
          if(this.dateType == '1'){
            options.title = { text: "温度平均值(小时)" };
          }else{
            options.title = { text: "温度平均值(天)" };
          }
          
          options.series[0].name = "平均值";
          options.series[1] = {}

          shebeiIndex = 0
          this.huanjingData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.wenduav.forEach((item) => {

              options.xAxis[0].data.push(item.hour)
              options.series[0].data.push(item.av)
            })
            this.$refs.huanjingavChart[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })




        })


        this.huanjingData.forEach((data) => {

          const days = []
          data.wendu.forEach((item) => {
            days.push(item.day)
          })
          const obj = {}
          const obj2 = {}
          const obj3 = {}
          const obj4 = {}
          days.forEach((item, index) => {
            obj[item] = data.wendu[index].max
            obj2[item] = data.wendu[index].maxTime.split(" ")[1]
            obj3[item] = data.wendu[index].min
            obj4[item] = data.wendu[index].minTime.split(" ")[1]
          })
          const huanjingTableData = [obj, obj2, obj3, obj4]
          data["huanjingTableData"] = huanjingTableData

        })
      },
      dnzl (data) {

        this.dnzlData = data.datas


        this.$nextTick(() => {

          let options = {
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let params1 = params[0];
                let params2 = params[1];
                return (
                  params.length == 1 ? params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value :

                    params1.marker + params1.seriesName + '<br/>' +
                    params1.axisValue + "：" + params1.value +
                    '<br/>' +
                    params2.marker + params2.seriesName + '<br/>' +
                    params2.axisValue + "：" + params2.value



                );
              },
              axisPointer: {
                animation: false
              }

            },
            title: { text: "功率因数统计" },
            color: ['#5470C6', '#00CE7C60'],
            legend: {},
            grid: {
              top: 30,
              bottom: 50
            },
            xAxis: [
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#5470C6'
                  }
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      return (
                        params.value +
                        (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                      );
                    }
                  }
                },
                // prettier-ignore
                data: []
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '最高',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [

                ]
              },
              {
                name: '最低',
                type: 'line',
                smooth: true,
                emphasis: {
                  focus: 'series'
                },
                data: [

                ]
              }
            ]
          }


          let shebeiIndex = 0
          this.dnzlData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.yinshu.forEach((item) => {

              options.xAxis[0].data.push(item.day)
              options.series[0].data.push(item.max)
              options.series[1].data.push(item.min)
            })
            this.$refs.dnzlChart[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })
          if(this.dateType == '1'){
            options.title = { text: "功率因数平均值(小时)" };
          }else{
            options.title = { text: "功率因数平均值(天)" };
          }
          
          options.series[0].name = "平均值";
          options.series[1] = {}

          shebeiIndex = 0
          this.dnzlData.forEach((data) => {
            options.xAxis[0].data = [];
            options.series[0].data = [];
            options.series[1].data = [];

            data.yinshuav.forEach((item) => {

              options.xAxis[0].data.push(item.hour)
              options.series[0].data.push(item.av)
            })
            this.$refs.dnzlavChart[shebeiIndex].setOption(options, true);
            shebeiIndex++
          })




        })


        // this.dnzlData.forEach((data) => {

        //   const days = []
        //   data.yinshu.forEach((item) => {
        //     days.push(item.day)
        //   })
        //   const obj = {}
        //   const obj2 = {}
        //   const obj3 = {}
        //   const obj4 = {}
        //   days.forEach((item, index) => {
        //     obj[item] = data.yinshu[index].max
        //     obj2[item] = data.yinshu[index].maxTime.split(" ")[1]
        //     obj3[item] = data.yinshu[index].min
        //     obj4[item] = data.yinshu[index].minTime.split(" ")[1]
        //   })
        //   const dnzlTableData = [obj, obj2, obj3, obj4]
        //   data["dnzlTableData"] = dnzlTableData

        // })
      },
      gjzl (data) {

        const datas = []
        data.forEach((item) => {
          const power = []
          {
            let tempArray = {}
            item.forEach((data) => {
              power.push(data.day);

              tempArray[data.day] = data.value

            })
            datas.push(tempArray)
            this.gjData["power"] = power
          }
        })

        this.gjData["powerValue"] = datas
      },
      ycyx (data) {
        this.ycyxData = data
      },
      yxyw (data) {
        this.yxywData = data
      }
    },
  }; </script>

<style media="print">
  html {
    height: auto;
    margin: 0px;
  }
</style>

<style lang="less" scoped>
  h {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 30px;
    font-weight: bold;
    width: 100%;
    text-align: center;
    display: block;
    margin-top: 40px;
  }

  h1 {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 20px;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  h2 {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 16px;
    display: block;
    margin-top: 20px;
    margin-left: 30px;
    margin-bottom: 20px;
  }

  h3 {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 14px;
    color: #121c26;
    font-weight: 600;
    text-align: left;
  }

  .el-table {
    font-size: 10px;
    position: inherit;
    overflow: inherit;
    padding: 0px;

    /deep/.el-table__cell {
      padding: 0px !important;
    }

    /deep/.tr_header {
      background-color: #edeff6;
      -webkit-print-color-adjust: exact;
    }

    /deep/.el-table__row--striped {
      -webkit-print-color-adjust: exact;
    }

    /deep/.cell_back_color {
      background-color: #FAFAFA !important;
      -webkit-print-color-adjust: exact;
    }

  }



  .box {
    display: flex;
    margin-top: 20px;

    .vflex {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      width: 150px;
    }

    .left {
      width: 300px; // width: 280px;

      .top {
        font-size: 30px;
        font-weight: 600;
        line-height: 68px;
        color: #1e60cf;
        letter-spacing: 1px;
      }

      .bottom {
        font-size: 14px;
        color: #132742;
      }
    }

    .middle {
      text-align: right;

      box-sizing: border-box;

      .top {
        font-size: 23px;
        color: #132742;
        line-height: 70px;
      }

      .bottom {
        font-size: 14px;
        color: #5a8fe8;

        img {
          width: 14px;
          height: 14px;
          position: relative;
          top: 2px;
          margin-left: 10px;
          margin-right: 2px;
        }
      }
    }

    .br {
      width: 1px;
      height: 105px;
      background: rgba(233, 233, 233, 1);
      margin-left: 10px;
      margin-right: 10px;
    }

    .right {
      align-content: center;
      padding-left: 30px;
      box-sizing: border-box;

      img {
        width: 30px;
        height: 30px;
      }

      .top {
        font-size: 15px;
        color: #181d33;
      }

      .bottom {
        font-size: 23px;
        color: #5a8fe8;
      }
    }


  }
</style>